import { Link } from 'react-router-dom';
import { packs } from '../data/packsData';
import { useCart } from '../context/CartContext';
import { createCartItemFromProduct } from '../utils/cartItem';
import { formatPrice } from '../utils/formatPrice';
import OptimizedImage from './OptimizedImage';

function PacksSection() {
  const { addItem } = useCart();

  const handleOrder = (pack) => {
    addItem(createCartItemFromProduct(pack));
  };

  return (
    <section className="packs-section" aria-label="Nos packs spéciaux">
      <div className="packs-section-inner">
        <header className="packs-section-header">
          <p className="packs-section-tag">Offres spéciales</p>
          <h2 className="packs-section-title">Nos packs</h2>
          <p className="packs-section-script">Anniversaire · Couple · Surprise &amp; plus</p>
          <p className="packs-section-lead">
            Des formules tout-en-un pensées pour vos moments spéciaux — fêtes, rendez-vous
            romantiques ou surprises gourmandes. Prêts à commander en un clic.
          </p>
        </header>

        <div className="packs-grid">
          {packs.map((pack) => (
            <article
              key={pack.id}
              className={`pack-card${pack.highlight ? ' pack-card-highlight' : ''}`}
            >
              {pack.highlight && <span className="pack-card-badge">Populaire</span>}

              <div className="pack-card-visual">
                <span className="pack-card-emoji" aria-hidden="true">{pack.emoji}</span>
                <OptimizedImage
                  image={pack.image}
                  alt={pack.name}
                  className="pack-card-image"
                  loading="lazy"
                />
              </div>

              <div className="pack-card-body">
                <p className="pack-card-tagline">{pack.tagline}</p>
                <h3 className="pack-card-title">{pack.name}</h3>
                <p className="pack-card-desc">{pack.desc}</p>

                <ul className="pack-card-contents">
                  {pack.contents.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>

                <div className="pack-card-footer">
                  <span className="pack-card-price">{formatPrice(pack.basePrice)}</span>
                  <button
                    type="button"
                    className="btn-add"
                    onClick={() => handleOrder(pack)}
                  >
                    Commander
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="packs-section-cta">
          <Link to="/menu?category=packs" className="btn btn-primary">
            Voir tous les packs
          </Link>
        </div>
      </div>
    </section>
  );
}

export default PacksSection;
